// extracted by mini-css-extract-plugin
export default {"quantity":"calculation-config_quantity__tp9It"};